import { render, staticRenderFns } from "./HeadingLeft.vue?vue&type=template&id=5cb9524b&scoped=true&"
import script from "./HeadingLeft.vue?vue&type=script&lang=js&"
export * from "./HeadingLeft.vue?vue&type=script&lang=js&"
import style0 from "./HeadingLeft.vue?vue&type=style&index=0&id=5cb9524b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb9524b",
  null
  
)

export default component.exports